<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M2,0C2,0,2,4,2,4C2,6.97,4.16,9.43,7,9.91C7,9.91,7,14,7,14C7,14,5,14,5,14C4.45,14,4,14.45,4,15C4,15.55,4.45,16,5,16C5,16,11,16,11,16C11.55,16,12,15.55,12,15C12,14.45,11.55,14,11,14C11,14,9,14,9,14C9,14,9,9.91,9,9.91C11.84,9.43,14,6.97,14,4C14,4,14,0,14,0C14,0,2,0,2,0C2,0,2,0,2,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Glass',
} as DefineComponent
</script>
